import styles from './styles.module.css'
import AnchorLink from '../AnchorLink';
import { FaArrowRightLong } from 'react-icons/fa6';

const Card = ({title,imageUrl,link}) => {
  

    return (
        <div className={styles['slider-card']}> 					
            <div className={styles['image-area']}>
                <img
                    alt={title || ''}
                    src={imageUrl}
                    style={{ width: '100%', height: 'auto' }}
                />              
            </div>
            <div className={styles['slider-body']}>
                <h3>{title || ''}</h3>	
                <div className='mt-3'>
                    <AnchorLink 
                        title={link.title}
                        className='mt-4'
                        href={'#!'}
                        icon={<FaArrowRightLong className='ms-2' size={20} />}
                        iconPostion='right'
                    />
                </div>             
            </div>
        </div>
    );
};

export default Card;